import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { TextField, Button, Typography, Grid, Box, InputAdornment } from "@mui/material";
import "./reset-password.css"; // Keep your custom styles here
import { FaEnvelope } from "react-icons/fa";

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
});

const ResetPassword = () => {
  const navigate = useNavigate();

  const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
    try {
      await axios.post(
        "/api/auth/request-reset-password",
        { email: values.email },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      navigate("/validate-otp", { state: { email: values.email } });
    } catch (err) {
      setFieldError("email", "Invalid email or request failed");
      setSubmitting(false);
    }
  };

  return (
    <Grid container className='reset-container'>
      <Grid item xs={12} sm={8} md={4}>
        <Box className='reset-form' p={4}>
          <img src='/images/lock.png' alt='' className='lock' />
          <Typography variant='h5' align='center' gutterBottom>
            Reset Your Password
          </Typography>
          <Typography variant='body1' align='center' gutterBottom>
            Forget your password enter your email and <br />
            we’ll send you the instructions to reset it
          </Typography>

          <Formik initialValues={{ email: "" }} validationSchema={validationSchema} onSubmit={handleSubmit}>
            {({ isSubmitting, errors, touched, handleChange }) => (
             <Form className='form-details'>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box>
                      <TextField
                        fullWidth
                        name='email'
                        type='email'
                        variant='outlined'
                        placeholder='Enter your Email'
                        onChange={handleChange}
                        error={touched.email && Boolean(errors.email)}
                        helperText={touched.email && errors.email}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position='start'>
                              <FaEnvelope />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "white",
                            position: "relative",
                            marginBottom: "5px",
                            width: "100%",
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            fontSize: "15px",
                          },
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} className='reset-button'>
                    <Button fullWidth variant='contained' type='submit' disabled={isSubmitting}>
                      {isSubmitting ? "Sending..." : "Send OTP"}
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ResetPassword;
